import {SearchFilters} from './searchFilters';

export const JobBoardSearchFilters = SearchFilters.extend({
    url: '/jobs/filters.json',
});
